import React from 'react';
import FieldMappingEditor from '../components/FieldMappingEditor';

export default function FieldMappingsPage() {
	return (
		<div className="field-mappings-page">
			<h2>Field Mappings</h2>
			<p className="page-subtitle">Configure how CRM fields map to API payloads for each integration step.</p>
			<FieldMappingEditor />
		</div>
	);
}
